"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CodeSnippetDropdown;

var _react = _interopRequireDefault(require("react"));

var _excluded = ["options", "onChange"],
    _excluded2 = ["label", "value"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function CodeSnippetDropdown(_ref) {
  var options = _ref.options,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("select", _extends({
    className: "p-code-snippet__dropdown",
    onChange: onChange
  }, props), options.map(function (_ref2) {
    var label = _ref2.label,
        value = _ref2.value,
        props = _objectWithoutProperties(_ref2, _excluded2);

    return /*#__PURE__*/_react.default.createElement("option", _extends({
      value: value,
      key: value + "" || label
    }, props), label);
  }));
}